import React from 'react';
import CopyRight from './CopyRight';

const Footer: React.FC<{}> = () => (
    <CopyRight />
);

export default Footer;